var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    Error - Page Not Found\n    "),_c('div',{staticClass:"link",on:{"click":_vm.changePage}},[_vm._v("Go to home page\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }